import { render, staticRenderFns } from "./rtwo.vue?vue&type=template&id=afa61fde&scoped=true&"
import script from "./rtwo.vue?vue&type=script&lang=js&"
export * from "./rtwo.vue?vue&type=script&lang=js&"
import style0 from "./rtwo.vue?vue&type=style&index=0&id=afa61fde&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afa61fde",
  null
  
)

export default component.exports